export const PossessionTeam = {
  HOME: "HOME",
  AWAY: "AWAY",
  NONE: "",
}